// temboye-animations.js — Apple-style scroll animations
(function () {
  'use strict';

  // Scroll Reveal via IntersectionObserver
  const observer = new IntersectionObserver(
    (entries) => entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('t-visible'); observer.unobserve(e.target); }
    }),
    { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
  );

  function tagReveal() {
    const sels = [
      '.card-wrapper', '.collection-list__item', '.blog-articles__article',
      '.featured-collection .grid__item', '.rich-text__blocks > *',
      '.section-header', '.footer__content-top > *'
    ];
    sels.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el, i) => {
        if (!el.classList.contains('t-reveal')) {
          el.classList.add('t-reveal');
          if (i > 0 && i < 5) el.style.transitionDelay = (i * 0.08) + 's';
        }
        observer.observe(el);
      });
    });
    document.querySelectorAll('.t-reveal:not(.t-visible)').forEach((el) => observer.observe(el));
  }

  // Header shadow on scroll
  function initHeader() {
    const h = document.querySelector('.shopify-section-header, header.header');
    if (!h) return;
    window.addEventListener('scroll', () => {
      h.style.boxShadow = window.scrollY > 60 ? '0 2px 24px rgba(10,10,10,0.10)' : '';
    }, { passive: true });
  }

  // Hero parallax
  function initParallax() {
    const img = document.querySelector('.banner__media img, .t-hero__image');
    if (!img) return;
    window.addEventListener('scroll', () => {
      if (window.scrollY < window.innerHeight)
        img.style.transform = 'scale(1.05) translateY(' + (window.scrollY * 0.12) + 'px)';
    }, { passive: true });
  }

  // Subtle card tilt on hover
  function initTilt() {
    document.querySelectorAll('.card-wrapper').forEach((card) => {
      card.addEventListener('mousemove', (e) => {
        const r = card.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width - 0.5) * 6;
        const y = ((e.clientY - r.top) / r.height - 0.5) * -6;
        card.style.transform = `perspective(800px) rotateY(${x}deg) rotateX(${y}deg) translateY(-3px)`;
        card.style.transition = 'transform 0.1s ease';
      });
      card.addEventListener('mouseleave', () => {
        card.style.transform = '';
        card.style.transition = 'transform 0.5s cubic-bezier(0.16,1,0.3,1)';
      });
    });
  }

  // Ken Burns for hero
  function initHero() {
    const hero = document.querySelector('.t-hero');
    if (hero) requestAnimationFrame(() => hero.classList.add('t-hero--loaded'));
  }

  // Smooth anchor scroll
  document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const t = document.querySelector(a.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  function init() {
    tagReveal();
    initHeader();
    initParallax();
    initTilt();
    initHero();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  document.addEventListener('shopify:section:load', () => { tagReveal(); initTilt(); });
})();